import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {

  constructor(private http: HttpClient) { }
  Post(url: string, request: any, options: object): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(url, request, options).pipe(retry(1), catchError(this.handleError));
  }

  Get(url: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(url).pipe(retry(1), catchError(this.handleError));
  }

  /*
   * Error Handling
   **/
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    if(error.error.ErrorMessage && error.error.ErrorMessage !== ''){
      const clientError = error.error.ErrorMessage;
      return throwError(clientError);
    }
    return throwError(errorMessage);
  }

}
